/* eslint-disable no-param-reassign */
import axios from 'axios'

const instance = axios.create()

instance.interceptors.request.use((config) => {
  // eslint-disable-next-line max-len
  if (config.url && config.url.includes('myAccount') && !(config.url.includes('login') || (config.url.includes('signup')))) {
    config.headers.Authorization = localStorage.getItem('jwtToken')
  }
  return config
}, (error) => Promise.reject(error))

const makeRequest = async (url, method, data = {}) => {
  const response = await instance({
    url,
    method,
    data,
  })
  return response
}

const login = (data) => makeRequest(`${ process.env.REACT_APP_URL }/login`, 'POST', data)

const signup = (data) => makeRequest(`${ process.env.REACT_APP_URL }/sign-up`, 'POST', data)

const getRequest = (url) => makeRequest(url, 'GET')

const postRequest = (url, data) => makeRequest(url, 'POST', data)

const putRequest = (url, data) => makeRequest(url, 'PUT', data)

const deleteRequest = (url) => makeRequest(url, 'DELETE')

export {
  login, signup, getRequest, postRequest, putRequest, deleteRequest,
}
